import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PagingData, ServerResponse } from '../models';
import {
  CrmFrontMessage,
  FrontTopMessageSummary,
  MessageFileDownloadEvent,
} from '../models/message.model';
import { PolarJService } from './polarj.service';
import { MODULE_SERVICE_NAME, PolarJServerModelContextPath } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class AmmMessageService {
  private _polarjService: PolarJService = inject(PolarJService);

  fetchConversationByTopMsgId(
    topMsgId: number,
    pageIndex: number = 0,
    pageSize: number = 50,
    sortField: string = 'createdDate',
    sortType: string = 'desc'
  ): Observable<PagingData<CrmFrontMessage>> {
    const urlPara = `pageIndex=${pageIndex}&pageSize=${pageSize}&sorts=${sortField} ${sortType}`;

    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.CRM,
      modelName: PolarJServerModelContextPath.CRM_MESSAGES,
      requestMappingString: topMsgId + '/all',
      urlPara: urlPara,
      enableErrorMsg: true,
      singleData: false,
      pageData: true,
    });
  }

  fetchTopMessage(
    type?: string
  ): Observable<PagingData<FrontTopMessageSummary>> {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.CRM,
      modelName: PolarJServerModelContextPath.CRM_MESSAGES,
      requestMappingString: 'searchTopMsg',
      enableErrorMsg: true,
      singleData: false,
      pageData: true,
      urlPara: 'includeArchived=1',
    });
  }

  replyMessageByTopId(
    msg: CrmFrontMessage,
    topMsgId: number
  ): Observable<CrmFrontMessage> {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.CRM,
      modelName: PolarJServerModelContextPath.CRM_MESSAGES,
      requestMappingString: topMsgId + '/reply',
      para: msg,
      enableErrorMsg: true,
      singleData: true,
    });
  }

  fetchAllMessageById(id: number): Observable<PagingData<CrmFrontMessage>> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.CRM,
      modelName: PolarJServerModelContextPath.CRM_MESSAGES,
      requestMappingString: id + '/all',
      enableErrorMsg: true,
      pageData: true,
    });
  }

  setWholeThreadToReadStatus(ids: Array<number>): Observable<number> {
    return this._polarjService.postCall({
      moduleServiceName: MODULE_SERVICE_NAME.CRM,
      modelName: PolarJServerModelContextPath.CRM_MESSAGES,
      requestMappingString: ids.join(',') + '/readAll',
      singleData: true,
    });
  }

  /**
   * Download file from message module
   * @param downloadEvent
   * @returns file downloaded blob
   */
  downloadMessagingFile(
    downloadEvent: MessageFileDownloadEvent
  ): Observable<any> {
    return this._polarjService.downloadFileCall({
      moduleServiceName: MODULE_SERVICE_NAME.CRM,
      modelName: PolarJServerModelContextPath.CRM_MESSAGES,
      requestMappingString: `${downloadEvent.messageId}/attachment/${downloadEvent.attachmentId}`,
      enableErrorMsg: true,
      singleData: true,
      pageData: false,
    });
  }

  requestConversation(
    storeOwnerId: number,
    storeCode: string
  ): Observable<ServerResponse> {
    return this._polarjService.postCalAsServerResponse({
      moduleServiceName: MODULE_SERVICE_NAME.CRM,
      modelName: PolarJServerModelContextPath.CRM_AUTOMATIONS,
      requestMappingString: 'requestConv',
      para: {
        senderId: storeOwnerId,
        groupRef: storeCode,
      },
    });
  }
  checkSubscribeCondition(code: string,userId:number,email:string): Observable<boolean> {
    return this._polarjService.getCall({
      moduleServiceName: MODULE_SERVICE_NAME.CRM, modelName: PolarJServerModelContextPath.CRMFEED_SUBSCRIPTIONS,
      requestMappingString: code +'/'+userId+ '/OUT_OF_STOCK',
      urlPara:'email='+email,
      enableErrorMsg: true, singleData: true
    });
  }
}
